import { render, staticRenderFns } from "./view-purchase-order-expand.vue?vue&type=template&id=186c83d4&scoped=true&"
import script from "./view-purchase-order-expand.vue?vue&type=script&lang=js&"
export * from "./view-purchase-order-expand.vue?vue&type=script&lang=js&"
import style0 from "./view-purchase-order-expand.vue?vue&type=style&index=0&id=186c83d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186c83d4",
  null
  
)

export default component.exports